import { saveSteamUserInfoEndpoint, } from 'root/src/server/modules/steam/endpoints/saveSteamUserInfo.endpoint';
import { initSteamReviewsReportEndpoint } from 'root/src/server/modules/steam/endpoints/initSteamReviewsReport.endpoint';
export const steamEndpoints = Object.assign(Object.assign({}, saveSteamUserInfoEndpoint), initSteamReviewsReportEndpoint);
